import api from '../api'

export const postStock = (params) => api.post('/farms/agricultures/stocks', params)

export const putStock = (params) => api.put(`/farms/agricultures/stocks/${ params.id }`, params)

export const deleteStock = (params) => api.delete(`/farms/agricultures/stocks/${ params.id }`)

export const postRawMaterial = (params) => api.post('/farms/agricultures/inputs', params)

export const putRawMaterial = (params) => api.put(`/farms/agricultures/inputs/${ params.id }`, params)

export const deleteRawMaterial = (params) => api.delete(`/farms/agricultures/inputs/${ params.id }`)
